import { render, staticRenderFns } from "./screenpic.vue?vue&type=template&id=31b53385&scoped=true&"
import script from "./screenpic.vue?vue&type=script&lang=js&"
export * from "./screenpic.vue?vue&type=script&lang=js&"
import style0 from "./screenpic.vue?vue&type=style&index=0&id=31b53385&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b53385",
  null
  
)

export default component.exports